
function _axis() {
  let that = this;
  let scale = this.__execs__.scale;
  let axisToggles = this.axis();
  let facet = this.facet();
  let grid = this.grid();
  let innerSize = this.innerSize();
  let field = this.__execs__.field;

  let _axisScaleX = function (axisToggle) {
    axisToggle.field = field.x.field;
    let curAxis = that.axisDefault(scale.x, axisToggle);
    if (axisToggle.orient === 'bottom') curAxis.y(scale.y.range()[0]);
    curAxis.grid(grid).gridSize(innerSize.height);
    return curAxis;
  }

  let _axisScaleY = function (axisToggle) {
    axisToggle.field = field.y.field;
    let curAxis = that.axisDefault(scale.y, axisToggle);
    if (axisToggle.orient === 'right') curAxis.x(scale.x.range()[1]);
    curAxis.grid(grid).gridSize(innerSize.width);
    return curAxis;
  }

  let xAt = axisToggles.find( d => d.target === 'x');
  let yAt = axisToggles.find( d => d.target === 'y');
  if (this.isFacet()) { //TODO: facet 일 경우 공통요소
    //horizontal 일 경우 top d1
    //vertical 일 경우 right d1
    if (facet.orient === 'horizontal' && xAt) {
      xAt.field = field.region.field;
      xAt.orient = 'top';
      xAt.showDomain = false;
      this.axisDefault(scale.region, xAt);
    } else if (facet.orient === 'vertical' && yAt) {
      yAt.field = field.region.field;
      yAt.orient = 'right';
      yAt.showDomain = false;
      this.axisDefault(scale.region, yAt).x(innerSize.width);
    }
  } else {
    if (xAt) {
      _axisScaleX(xAt);
    } 
    if (yAt) {
      _axisScaleY(yAt);
    }
  }

  this.renderAxis();
}

export default _axis;


// WEBPACK FOOTER //
// ./layouts/scatter/_axis.js